// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminBrands = (client) => ({
    /**
     * `POST /admin/brands`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminBrandsCreate
     * @source packages/modules/b2c-core/src/api/admin/brands/route.ts
     */
    create: (body, query, headers) => client.fetch("/admin/brands", { method: "POST", body, query, headers }),
    /**
     * `GET /admin/brands`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminBrandsList
     * @source packages/modules/b2c-core/src/api/admin/brands/route.ts
     */
    list: (query, headers) => client.fetch("/admin/brands", { method: "GET", query, headers }),
});
//# sourceMappingURL=brands.js.map